import React, { memo, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FloatIcon } from './CurrencyIcons';
import { iconUrl } from '../utils/assets';
import { useLocale } from '../i18n/LocaleContext';

const MenuBar = memo(function MenuBar() {
  const { pathname } = useLocation();
  const { t } = useLocale();

  const ITEMS = [
    { to: '/clicker', icon: 'home.png', label: t('navHome') },
    { to: '/clicker/upgrade', icon: 'toolbox.png', label: t('navBuild') },
    { to: '/clicker/earn', icon: 'crown.png', label: t('navPass') },
    { to: '/clicker/top', icon: 'trophy.png', label: t('navSeason') },
    { to: '/clicker/hub', icon: 'folder.png', label: t('navMore') },
  ];

  const isActive = useCallback(
    (to) => {
      if (to === '/clicker') return pathname === '/clicker';
      return pathname === to || pathname.startsWith(`${to}/`);
    },
    [pathname]
  );

  const hapticSelect = () => {
    try {
      window.Telegram?.WebApp?.HapticFeedback?.selectionChanged();
    } catch (_) {
      /* ignore */
    }
  };

  return (
    <div className="menu-bar">
      <nav className="menu-bar-nav glass-panel" aria-label="Navigation">
        {ITEMS.map(({ to, icon, label }) => {
          const active = isActive(to);
          return (
            <Link
              key={to}
              to={to}
              className={`menu-button ${active ? 'select' : 'no-select'}`}
              aria-current={active ? 'page' : undefined}
              onClick={hapticSelect}
            >
              <span className={`menu-icon-shell ${active ? 'is-active' : ''}`}>
                <FloatIcon
                  src={iconUrl(icon)}
                  size={28}
                  className={active ? 'menu-icon-active' : 'menu-icon'}
                  animated={active}
                  eager
                  native
                />
              </span>
              <span className="nav-span-11">{label}</span>
              {active ? <span className="menu-glow" aria-hidden /> : null}
            </Link>
          );
        })}
      </nav>
    </div>
  );
});

export default MenuBar;
